import { CampaignType } from 'modules/domains/campaign';
import { CampaignStep, PriorityLevelDisplay } from './types';
import { WhatsAppSendLimit } from 'modules/graphql';
import { EnumMapper } from './components/constants';

export const CAMPAIGN_STEP_NAMES_MAPPER: { [key in CampaignStep]?: string } = {
  [CampaignStep.Content]: 'Content',
  [CampaignStep.Delivery]: 'Delivery',
  [CampaignStep.Summary]: 'Summary',
  [CampaignStep.Audience]: 'Audience',
  [CampaignStep.AudienceTriggered]: 'Audience',
  [CampaignStep.ConversionAndExperiment]: 'Conversions and Experiments',
  [CampaignStep.Conversions]: 'Conversions',
  [CampaignStep.AudienceEligibility]: 'Audience',
  [CampaignStep.Display]: 'Display',
};

export const PRIORITY_LEVEL_VALUES: Record<PriorityLevelDisplay, number> = {
  [PriorityLevelDisplay.Low]: 400.5,
  [PriorityLevelDisplay.Medium]: 300.5,
  [PriorityLevelDisplay.High]: 200.5,
  [PriorityLevelDisplay.Critical]: 100.5,
};

export const PRIORITY_DISPLAY_VALUES: Record<number, PriorityLevelDisplay> = {
  400.5: PriorityLevelDisplay.Low,
  300.5: PriorityLevelDisplay.Medium,
  200.5: PriorityLevelDisplay.High,
  100.5: PriorityLevelDisplay.Critical,
};

/**
 * Names used as unique identifiers in React Hook Form
 * for the PrimaryContentProvider context
 */
export const CAMPAIGN_EDITOR_FORM_FIELDS = {
  CAMPAIGN_ALERTS_ENABLED: 'campaignAlertsEnabled',
  IGNORE_FREQUENCY_CAP: 'ignoreFrequencyCap',
  USE_QUIET_HOURS: 'useQuietHours',
  CUSTOM_QUIET_HOURS: 'customQuietHours',
  USE_RATE_LIMIT: 'useRateLimit',
  RATE_LIMIT: 'rateLimit',
  USE_SEND_TIME_OPTIMIZATION: 'useSendTimeOptimization',
  STO_COMPLETION_TIME: 'stoCompletionTime',
  PRIORITY_LEVEL: 'priorityLevel',
} as const;

export const CAMPAIGN_EDITOR_DISPLAY_CONTENT = {
  NO_PROJECT_LEVEL_ALERTS_TOOLTIP_TEXT:
    'Project alert settings must be enabled before using this feature in campaigns.',
};

export const NO_PROJECT_ALERTS_TOOLTIP_CONTENT = `This project does not have any eligible alerts`;

/* Alerts return Triggered instead of ApiTriggered.
  The rest is just to satisfy typing */
export const CAMPAIGN_TYPE_MAPPER = {
  [CampaignType.ApiTriggered]: 'Triggered',
  [CampaignType.Blast]: 'Blast',
  [CampaignType.Eligibility]: 'Eligibility',
  [CampaignType.WorkflowTriggered]: 'Triggered',
  [CampaignType.WithAI]: 'WithAI',
  [CampaignType.WithExperiment]: 'WithExperiment',
};

export const WHATSAPP_SEND_LIMIT_SHORT_TEXT_MAPPER: EnumMapper<WhatsAppSendLimit, string> = {
  [WhatsAppSendLimit.Limit100K]: '100K',
  [WhatsAppSendLimit.Limit10K]: '10K',
  [WhatsAppSendLimit.Limit1K]: '1K',
  [WhatsAppSendLimit.Limit250]: '250',
  [WhatsAppSendLimit.Limit50]: '50',
  [WhatsAppSendLimit.LimitNa]: 'N/A',
  [WhatsAppSendLimit.Unlimited]: 'Unlimited',
};
